import { useState } from 'react'
import { Outlet } from 'react-router'
import { RatingNudgeBanner } from './RatingNudgeBanner'
import { Sidebar } from './Sidebar'
import { SyncBanner } from './SyncBanner'
import { Topbar } from './Topbar'
import type { Group, Friend } from '@/types'

interface AppShellProps {
  groups: Group[]
  groupsLoading: boolean
  currentUser: Friend
}

export function AppShell({ groups, groupsLoading, currentUser }: AppShellProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <div className="cg-app">
      <div
        className="cg-sidebar-overlay"
        data-open={sidebarOpen}
        onClick={() => setSidebarOpen(false)}
      />
      <Sidebar
        groups={groups}
        groupsLoading={groupsLoading}
        currentUser={currentUser}
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />
      <main className="cg-main">
        <Topbar onMenuOpen={() => setSidebarOpen(true)} />
        <SyncBanner />
        <RatingNudgeBanner />
        <Outlet />
      </main>
    </div>
  )
}
